import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "pages/Home";
import NotFound from "pages/NotFound";
const WwwrivaltechcombyhtmltodesignFREEversion10Three = React.lazy(() =>
  import("pages/WwwrivaltechcombyhtmltodesignFREEversion10Three")
);
const ProjectRoutes = () => {
  return (
    <React.Suspense fallback={<>Loading...</>}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
          <Route
            path="/wwwrivaltechcombyhtmltodesignfreeversion10three"
            element={<WwwrivaltechcombyhtmltodesignFREEversion10Three />}
          />
        </Routes>
      </Router>
    </React.Suspense>
  );
};
export default ProjectRoutes;
